/* eslint-disable prefer-arrow-callback */
import { useEffect } from "react";

/** Adds the stylesheet to the document head while mounted, for rules such as @page that a component can't scope. */
export const useInjectedStylesheet = (css: string) => {
  useEffect(
    function injectStylesheet() {
      const styleEl = document.createElement("style");
      styleEl.textContent = css;
      document.head.appendChild(styleEl);
      return () => {
        document.head.removeChild(styleEl);
      };
    },
    [css]
  );
};
